import { render, staticRenderFns } from "./OptionsListSlug.vue?vue&type=template&id=2633438c"
import script from "./OptionsListSlug.vue?vue&type=script&lang=js"
export * from "./OptionsListSlug.vue?vue&type=script&lang=js"
import style0 from "./OptionsListSlug.vue?vue&type=style&index=0&id=2633438c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports